import { ErrorSnackbar } from '@components/snackbars/ErrorSnackbar';
import { useSnackbarState } from '@components/snackbars/useSnackbarState';
import { atom, useAtom } from 'jotai';

export const errorMessageAtom = atom<unknown | undefined>(undefined);

export default () => {
  const [error, setError] = useAtom(errorMessageAtom);
  const snackbarState = useSnackbarState(error, () => setError(undefined));

  return <ErrorSnackbar error={error} {...snackbarState} />;
};
